import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useBillingAccess } from '@/hooks/billing/useBilling';

/**
 * Renders the Billing route only while billing applies to the company
 * (master flag on, or a super admin's preview), and sends anyone who reaches
 * it by URL back to Organization otherwise: with billing off, nothing about
 * it shows.
 */
export function BillingGuard({ children }: { children: ReactNode }) {
  const { visible, isResolved } = useBillingAccess();

  if (!isResolved) return null;
  if (!visible) return <Navigate to="/organization" replace />;
  return children;
}
